import { FC } from 'react';
import {
    ErrorMessage,
    GrowthRateBasisType,
    Nullable,
    ProjectedGrowthRateValues,
    ReferenceData,
} from '@xplan-pension-switching/common';
import {
    IressDivider,
    IressForm,
    IressFormFieldset,
    IressRadio,
    IressRadioGroup,
    IressStack,
} from '@iress-oss/ids-components';
import { Section } from '../../Section/Section';
import { ProjectedGrowthRatesTable } from './GrowthRateTable';

export const ProjectedGrowthRates: FC<{
    projectedGrowthRates: Nullable<ProjectedGrowthRateValues>;
    referenceData: ReferenceData;
}> = ({ projectedGrowthRates, referenceData }) => {
    const { watch } = IressForm.useFormContext();
    const growthRateBasisDefaultValue = projectedGrowthRates
        ? projectedGrowthRates.growthRateBasis
        : GrowthRateBasisType.IndustryStandard;
    const growthRateBasisFormValue = watch('projectedGrowthRates.growthRateBasis', growthRateBasisDefaultValue);

    return (
        <Section heading="Projected growth rates" headingLevel="h3">
            <IressStack gutter="lg">
                <IressFormFieldset
                    label="Growth rate type"
                    name="projectedGrowthRates.growthRateBasis"
                    defaultValue={growthRateBasisDefaultValue}
                    rules={{ required: ErrorMessage.SelectAnOption }}
                    render={controlledProps => (
                        <IressRadioGroup layout="inline" {...controlledProps}>
                            <IressRadio data-testid="rdIndStandard" value={GrowthRateBasisType.IndustryStandard}>
                                Industry standard
                            </IressRadio>
                            <IressRadio data-testid="rdFundSpecNom" value={GrowthRateBasisType.FundSpecificNominal}>
                                Fund specific: nominal
                            </IressRadio>
                            <IressRadio data-testid="rdFundSpecInf" value={GrowthRateBasisType.FundSpecificInflation}>
                                Fund specific: inflation
                            </IressRadio>
                        </IressRadioGroup>
                    )}
                />
                <IressDivider />
                <ProjectedGrowthRatesTable
                    selectedGrowthRateBasisType={growthRateBasisFormValue}
                    defaultGrowthRateBasisType={projectedGrowthRates?.growthRateBasis}
                    growthRateHigh={projectedGrowthRates?.growthRateHigh}
                    growthRateMid={projectedGrowthRates?.growthRateMid}
                    growthRateLow={projectedGrowthRates?.growthRateLow}
                    referenceData={referenceData}
                />
            </IressStack>
        </Section>
    );
};
